import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import bookDataReducer from './slices/bookDataSlice';
import onlineUsersSlice from "./slices/onlineUsersSlice"; 
import languageReducer from "./slices/languageSlice";
import bookStatsReducer from "./slices/bookStatsSlice"; 
import latestChaptersReducer from "./slices/latestChaptersSlice";
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import notificationsReducer from "./slices/notificationsSlice";

import { enableMapSet } from "immer";
enableMapSet(); // ✅ ДОЛЖЕН БЫТЬ ПЕРВЫМ
export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        bookData: bookDataReducer,
        notifications: notificationsReducer,
        onlineUsers: onlineUsersSlice,
        language: languageReducer,
        bookStats: bookStatsReducer,
        latestChapters: latestChaptersReducer,
        ui: uiReducer,
    },
});

export default store;
